import { M_TO_FT } from './conversionFactors';

export const convertFbaSurvey = (value, units) => { // convert FBA field data to metric
  try {
    if (units === 'field') {
      return value;
    } else {
      return (value * M_TO_FT);
    };
  } catch (error) {
    return value;
  };
};
